import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function OtrasDisposiciones() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>XVIII. OTRAS DISPOSICIONES</h4>
          <br></br>

          <ul style={{ paddingLeft: '20px' }}>
            <br></br>
            <li>
              <p>
                <strong>CESIÓN:</strong> El Usuario/ Cliente Corporativo no podrá ceder ni transferir estas Condiciones, en todo o en parte, sin el consentimiento previo por escrito de Parking. El Usuario/ Cliente Corporativo da su aprobación a Parking para ceder o transferir estas Condiciones, en todo o en parte, incluido a: (i) un aliado; (ii) una subsidiaria o un afiliado; (iii) un adquirente del capital, del negocio o de los activos de Parking; o (iv) un sucesor por fusión. No existe entre usted, Parking o cualquier Tercer proveedor una empresa conjunta o relación de socios, empleo o agencia como resultado del contrato entre usted y Parking o del uso de los Servicios.
              </p>
            </li>
            <li>
              <p>
                <strong>LEY VIGENTE:</strong> Estos Términos de uso se regirán e interpretarán de conformidad con las leyes de la República de Colombia.
              </p>
            </li>
            <li>
              <p>
                <strong>PROPIEDAD INTELECTUAL:</strong> Todas las marcas registradas de Parking, marcas de servicio, nombres comerciales, logotipos, nombres de dominio y cualquier otra característica de la marca Parking y Go Parking son propiedad exclusiva de Parking o sus licenciantes. La prestación del servicio y uso de la App no le otorga derecho alguno al Usuario y al Cliente Corporativo para usar las Características de la marca Parking y Go Parking, ya sea para uso comercial o no comercial.
              </p>
            </li>
            <li>
              <p>
                <strong>COMUNICACIONES ELECTRÓNICAS:</strong> El Usuario/ Cliente Corporativo autoriza que el correo electrónico proporcionado en el registro será el medio de comunicación respecto de la información relativa a su cuenta (por ejemplo, las autorizaciones de pago, las facturas, el QR, los cambios de contraseña o de la forma de pago, los mensajes de confirmación, los avisos).
              </p>
            </li>
            <li>
              <p>
                <strong>CONTINUACIÓN DE VIGENCIA:</strong> Si alguna de las disposiciones de estos T&C es declarada nula, ilegal o inaplicable, la validez, legalidad y aplicación las demás disposiciones se mantendrán incólumes y seguirán siendo aplicadas.
              </p>
            </li>
            <li>
              <p>
                <strong>INDEMNIDAD: </strong> El Usuario/ Cliente Corporativo acuerda mantener indemne y responder frente a Parking y sus consejeros, directores, empleados y agentes por cualquier reclamación, demanda, pérdida, responsabilidad y gasto (incluidos los honorarios de abogados) que se deriven de: (i) el uso indebido de las Plataformas, los productos y /o Servicios que se oferten en la misma; (ii) su incumplimiento o violación de cualquiera de estas Condiciones; (iii) el uso por parte de Parking de su contenido de Usuario; o (iv) su infracción de los derechos de cualquier tercero, incluidos Terceros proveedores. 
              </p>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}